module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RE2ApP/tc-custom/9781439677605.jpg?1704887006487",
      "alt": "This image is the cover for the book Lincoln Funeral Train, The, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lincoln Funeral Train, The, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The effective end of the American Civil War on April 9, 1865, had hardly sunk in when, only five days later, another disaster stunned the battered and bloodied nation. On the night of April 9, Pres. Abraham Lincoln was assassinated. There would be time for vengeful thoughts later, but first the Great Emancipator was going to get a royal send-off. At the center of what would become a three-week national funeral was a spectacular train that would carry Lincoln's remains, and those of his deceased son, from Washington, DC, to Springfield, Illinois. \"The Lincoln Special\" steamed slowly out of spring mists, allowing thousands of mourners lining the tracks a lingering view. It was a logistics miracle; a romantic pageant of sorrow and wonder, carried off flawlessly. Through the tears, however, was a sense that America's identity had turned a corner and was about to enter a dynamic and hopeful future. Author of nine books, Michael Leavy is an avid Civil War and railroad historian. Leavy has searched through archives to locate rare photographs and new details and dispel some lingering myths surrounding this tragic but formative American event.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Leavy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author of nine books, Michael Leavy is an avid Civil War and railroad historian. Leavy has searched through archives to locate rare photographs and new details and dispel some lingering myths surrounding this tragic but formative American event.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0